import { APP_INITIALIZER, Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { InitUserGQL } from 'src/app/common/user/user.query.generated';
import { UserService } from 'src/app/common/user/user.service';
import { User } from 'src/types/graphql';

@Injectable({ providedIn: 'root' })
export class InitUserService {
  constructor(
    private userService: UserService,
    private initUserGQL: InitUserGQL,
  ) {}

  initUser() {
    return this.initUserGQL.fetch({}, { errorPolicy: 'ignore' }).pipe(
      map(r => r.data?.me),
      tap(u => this.userService.initUser(u)),
    );
  }
}

const initUserFactory = (initUserService: InitUserService) => (): Observable<Partial<User>> =>
  initUserService.initUser();

export const INIT_USER_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: initUserFactory,
  multi: true,
  deps: [InitUserService],
};
